import { ReactNode } from "react";
import AbstractDoc from "../AbstractDoc";

export default class Privacy_it extends AbstractDoc {

    protected getDoc(): ReactNode {
        return (
            <div>

                <h1>Privacy Policy</h1>

                <p>Effective Date: 23/08/2023</p>

                <p>PlayReverser ("Noi", "Il nostro", "Ci") si impegna a proteggere e rispettare la tua privacy. Con questa politica sulla privacy, intendiamo informarti su come raccogliamo, utilizziamo e proteggiamo le tue informazioni personali in relazione all'applicazione "CandyKu Sudoku" ("App").</p>

                <h2>Raccolta e Utilizzo delle Informazioni</h2>

                <h3>Dati Personali</h3>

                <p>La nostra App non raccoglie direttamente informazioni personali identificabili da parte dell'utente.</p>

                <h3>Raccolta di Dati da Terze Parti</h3>

                <p>La nostra App utilizza i seguenti servizi di terze parti che possono raccogliere informazioni utilizzate per identificare te come utente:</p>

                <ul>
                    <li><strong>Firebase:</strong> Utilizziamo Firebase Analytics per raccogliere dati sull'utilizzo dell'App, compresi dati sull'identificatore del dispositivo. Firebase è fornito da Google e la loro politica sulla privacy è disponibile su <a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a>.</li>
                    <li><strong>AdMob:</strong> Utilizziamo AdMob di Google per la pubblicità all'interno dell'App. AdMob può raccogliere dati sull'utente per la personalizzazione degli annunci. La politica sulla privacy di AdMob è disponibile su <a href="https://support.google.com/admob/answer/6128543?hl=en">https://support.google.com/admob/answer/6128543?hl=en</a>.</li>
                    <li><strong>Unity:</strong> La nostra App può utilizzare il motore di gioco Unity, che può raccogliere dati sull'utente. La politica sulla privacy di Unity è disponibile su <a href="https://unity3d.com/legal/privacy-policy">https://unity3d.com/legal/privacy-policy</a>.</li>
                </ul>

                <h2>Divulgazione delle Informazioni</h2>

                <p>Noi non vendiamo, commercializziamo o trasferiamo in altro modo le tue informazioni personali a terzi senza il tuo consenso.</p>

                <h2>Sicurezza</h2>

                <p>Noi adottiamo misure ragionevoli per proteggere le informazioni personali dall'accesso non autorizzato o dalla divulgazione.</p>

                <h2>Modifiche a questa Politica sulla Privacy</h2>

                <p>Questa politica sulla privacy può essere aggiornata periodicamente per riflettere eventuali modifiche nelle nostre pratiche di raccolta e utilizzo delle informazioni. Quando apportiamo modifiche, la data di "Effettiva Data" nella parte superiore della politica sulla privacy verrà aggiornata. Ti consigliamo di consultare periodicamente questa pagina per essere informato su come stiamo proteggendo le tue informazioni.</p>

                <h2>Contattaci</h2>

                <p>Per domande sulla nostra politica sulla privacy, ti preghiamo di contattarci a:</p>

                <p>playreverser@gmail.com</p>

            </div>
        );
    }

}